/**
 * 充值订单
 */
import React from 'react';
import styles from './index.module.scss';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { XInput, XOKButton, XCancelButton, XSelect, XDatePicker } from '@/components/xqxc_ui';
import model from '@/reducers/finance/enterpriserecharge/model';
import TableList from './components/TableList';
import KeepAlive from '@/routes/KeepAlive';
import { autoPageNum, autopageSize } from '@/assets/config';
import { SearchBox, SearchItem } from '@/components/Layout';
import { TableActionType as ta } from '@/util/enum';
import InvoiceModal from '../modal/InvoiceModal';

class Main extends React.Component {

    state = {
        tel: undefined,
        payId: undefined,
        otherId: undefined,
        payType: {},
        rechargeSource: {},
        startTime: undefined,
        endTime: undefined,
        pageNum: 1,
        pageSize: 10,
        selectedKeys: [],
        openModeParam: {},
        currentOpenMode: ''
    }

    componentDidMount() {
        this.props.getPayTypeList({ enumName: 'RechargePaymentChannelType' });
        this.props.getRechargeSourceList({ enumName: 'AppSystemType' });
    }

    // 查询
    _searchHandle = (useCache) => {
        const { tel, payId, otherId, payType, rechargeSource, startTime, endTime, pageNum, pageSize } = this.state;
        this.searchCache = {
            phone: tel,
            payNo: payId,
            thirdNo: otherId,
            payType: payType.code,
            platSource: rechargeSource.code,
            startTime,
            endTime,

            pageNum: useCache == 'useCache' ? pageNum : autoPageNum,
            pageSize: useCache == 'useCache' ? pageSize : autopageSize,
        };
        this.props.getRechargeList(this.searchCache);
        KeepAlive.saveCache({ ...this.state, pageNum: this.searchCache.pageNum, pageSize: this.searchCache.pageSize });
    }

    // 表格分页
    _paginationChange = (pageSize, pageNum) => {
        this.setState({ pageNum, pageSize }, () => this._searchHandle('useCache'));
    }

    // 重置
    _resetHandle = () => {
        this.setState({ tel: undefined, payId: undefined, otherId: undefined, payType: {}, rechargeSource: {}, startTime: undefined, endTime: undefined, pageNum: 1, pageSize: 10 }, () => {
            KeepAlive.saveResetFunc(this._searchHandle);
        });
    }

    // 关闭弹框
    _closeMode = (reload) => {
        this.setState({ currentOpenMode: '', openModeParam: {} });
        reload && this._searchHandle();
    }

    // 表格操作
    _tableAction = (key, type, item) => {
        switch (type) {
            case ta.sure:
                this.setState({ currentOpenMode: ta.sure, openModeParam: item });
        }
    }

    // 打开弹窗  
    _renderMode = () => {
        switch (this.state.currentOpenMode) {
            case ta.sure:
                return <InvoiceModal title='已开发票' visible={true} data={this.state.openModeParam} closeMode={this._closeMode} />;
            default:
                return null;
        }
    }

    render() {
        const { tel, payId, otherId, payType, rechargeSource, startTime, endTime } = this.state;
        let { curTabID, rechargeList, payTypeList, rechargeSourceList } = this.props;

        return (
            <KeepAlive id={curTabID} render={(state) => {
                if (!this.state.__aliveInit) {
                    this.setState({ ...state, __aliveInit: true }, () => {
                        this._searchHandle('useCache');
                    });
                }
            }}>
                <div className={styles.flexBoxContainer}>
                    <SearchBox>
                        <SearchItem>
                            <XInput
                                inputStyle={{ width: 130 }}
                                label='会员手机号'
                                placeholder='请输入'
                                value={tel}
                                bindThis={this}
                                bindName='tel'
                            />
                        </SearchItem>
                        <SearchItem>
                            <XInput
                                inputStyle={{ width: 170 }}
                                label='支付单号'
                                placeholder='请输入'
                                value={payId}
                                bindThis={this}
                                bindName='payId'
                            />
                        </SearchItem>
                        <SearchItem>
                            <XInput
                                inputStyle={{ width: 150 }}
                                label='第三方单号'
                                placeholder='请输入'
                                value={otherId}
                                bindThis={this}
                                bindName='otherId'
                            />
                        </SearchItem>
                        <SearchItem>
                            <XSelect
                                selectStyle={{ width: 120 }}
                                label='支付方式'
                                placeholder='请选择'
                                renderData={payTypeList}
                                dataIndex='value'
                                keyIndex='code'
                                value={payType.value}
                                bindThis={this}
                                bindName='payType'
                            />
                        </SearchItem>
                        <SearchItem>
                            <XSelect
                                selectStyle={{ width: 100 }}
                                label='充值来源'
                                placeholder='请选择'
                                renderData={rechargeSourceList}
                                dataIndex='value'
                                keyIndex='code'
                                value={rechargeSource.value}
                                bindThis={this}
                                bindName='rechargeSource'
                            />
                        </SearchItem>
                        <SearchItem>
                            <XDatePicker
                                label='支付时间'
                                datePickerStyle={{ width: 130 }}
                                value={startTime}
                                bindThis={this}
                                bindName='startTime'
                                defaultTime='00:00:00'
                                showTime={false}
                                isFormat
                            />
                            <XDatePicker
                                style={{ marginRight: 10 }}
                                datePickerStyle={{ width: 130 }}
                                label=''
                                value={endTime}
                                bindThis={this}
                                bindName='endTime'
                                showTime={false}
                                defaultTime='23:59:59'
                                isFormat
                            />
                        </SearchItem>
                        <SearchItem>
                            <XOKButton
                                style={{ marginLeft: '10px', width: '60px' }}
                                label='查询'
                                onClick={this._searchHandle}
                            />
                            <XCancelButton
                                style={{ marginLeft: '10px', width: '60px' }}
                                label='重置'
                                onClick={this._resetHandle}
                            />
                        </SearchItem>
                    </SearchBox>
                    <TableList renderData={rechargeList} tableAction={this._tableAction} paginationChange={this._paginationChange} />
                </div>
                {this._renderMode()}
            </KeepAlive>
        );
    }
}

Main.propTypes = {
    history: PropTypes.object,
    curTabID: PropTypes.string,

    getRechargeList: PropTypes.func,
    rechargeList: PropTypes.object,

    getPayTypeList: PropTypes.func,
    payTypeList: PropTypes.array,

    getRechargeSourceList: PropTypes.func,
    rechargeSourceList: PropTypes.array
};
const mapStateToProps = (state) => ({
    payTypeList: state.enterpriserecharge.payTypeList,
    rechargeSourceList: state.enterpriserecharge.rechargeSourceList,
    rechargeList: state.enterpriserecharge.rechargeList,
});

export default connect(mapStateToProps, { ...model.actions })(Main);